import { Component, OnDestroy } from '@angular/core';
import { Event } from '../../models/event.model';
import { EventService } from '../../services/event.service';
import { ListViewStateService } from '../../services/list-view-state.service';

@Component({
  selector: 'app-events-shell',
  templateUrl: './events-shell.component.html',
  providers: [ListViewStateService],
})
export class EventsShellComponent implements OnDestroy {
  constructor(
    private listViewState: ListViewStateService,
    private eventService: EventService<Event>
  ) { }

  ngOnDestroy(): void {
    this.listViewState.resetListViewState();
    this.eventService.resetEventListExpiredVisibility();
  }
}
